import { clsx } from 'clsx'
import { type FC } from 'react'

import { type ProductCarouselDotNavigationProps } from './ProductCarouselDotNavigationProps'

const ProductCarouselDotNavigation: FC<ProductCarouselDotNavigationProps> = ({
  className,
  currentIndex,
  images,
  onClick,
  videos,
}) => {
  const mediaToRender = [
    ...images,
    ...videos.map((video) => video.thumbnail ?? '').filter(Boolean),
  ]

  return (
    <div
      className={clsx(
        'flex w-[calc(100vw-15px)] justify-center overflow-hidden tablet:w-auto',
        className,
      )}
    >
      {mediaToRender.map((image, index) => (
        <button
          className={clsx(
            'mx-2 size-3.5 shrink-0 rounded-full border-2 border-dark-pressed-brand-medium',
            currentIndex === index && 'bg-dark-pressed-brand',
          )}
          key={image}
          onClick={(): void => {
            onClick(index)
          }}
          type="button"
        />
      ))}
    </div>
  )
}

export { ProductCarouselDotNavigation }
